import React, { useState } from "react";
import ResizeListner from "../../../../utility/ResizeListner";
import CustomSelect from "../custom_select";

const CustomTabs = ({
  activeIndex,
  tabs,
  body,
  passCurrentTab,
  underLineRequired = true,
  actionComponent,
  backgroundrequired = true,
  isActionComponentRequired = true,
  countComponent,
  containerStyle,
}) => {
  const { width, height } = ResizeListner();
  const [hovered, setHovered] = useState("");
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        borderBottom: "1px solid #f3f3f3",
        margin: "10px 0px",
        ...containerStyle,
      }}
    >
      <div
        style={{
          display: "flex",
          padding: "10px 20px",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", height: "100%" }}>
          {tabs &&
            tabs.map((data, index) => (
              <p
                style={{
                  backgroundColor: !backgroundrequired
                    ? "white"
                    : hovered === data.key
                    ? "rgba(111, 108, 255, 0.1)"
                    : data.key === activeIndex
                    ? "#38369C"
                    : "white",
                  borderRadius: "4px",
                  padding: backgroundrequired ? "10px 20px" : "10px 0px",
                  fontSize: 14,
                  fontWeight: "500",
                  cursor: "pointer",
                  color:
                    hovered === data.key && backgroundrequired
                      ? "#38369C"
                      : data.key === activeIndex
                      ? backgroundrequired
                        ? "#FDFDFD"
                        : "#38369C"
                      : "#6C6B6B",
                  marginRight: backgroundrequired ? "20px" : "40px",
                  border: !backgroundrequired
                    ? "0px solid transparent"
                    : hovered === data.key
                    ? "1px solid transparent"
                    : data.key === activeIndex
                    ? "1px solid #38369C"
                    : "1px solid #DFDFDF",
                  transition: "all 0.2s",
                }}
                key={index}
                onClick={() => {
                  passCurrentTab(data.key);
                  setHovered("");
                }}
                onMouseEnter={() => {
                  data.key !== activeIndex && setHovered(data.key);
                }}
                onMouseLeave={() => {
                  setHovered("");
                }}
              >
                {data.name}
              </p>
            ))}

          {countComponent}
        </div>
        {isActionComponentRequired && <div>{actionComponent}</div>}
      </div>

      <div>{body}</div>
    </div>
  );
};

export default CustomTabs;
